var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('img',{attrs:{"src":_vm.$store.state.static_img_url+'mobile/pic/404.png'}}),_c('p',[_vm._v("抱歉！您访问的页面不存在")]),_c('div',{on:{"click":_vm.backMain}},[_vm._v("\n    返回首页\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }